import { FeedArticle } from './parseFeed'

export type ContentfulBlogEntryFields = {
  postUrl: string
  postTitle: string
  postSummary: string
  headerImage?: { fields: { file?: { url: string } } }
}

export type ContentfulBlogEntry = {
  fields: ContentfulBlogEntryFields
  metadata: { tags: { sys: { id: string } }[] }
  sys: { id: string; updatedAt: string | Date }
}

export const toFeedArticle = (entry: ContentfulBlogEntry): FeedArticle => ({
  slug: entry.fields.postUrl,
  title: entry.fields.postTitle,
  summary: entry.fields.postSummary,
  image: entry.fields.headerImage?.fields.file
    ? `https:${entry.fields.headerImage.fields.file.url}`
    : null,
  date: new Date(entry.sys.updatedAt).toISOString(),
  tags: entry.metadata.tags.map((tag) => tag.sys.id),
})
